import React from "react";
import Sidebar from "./components/Sidebar/Sidebar";
import AdminNavbar from "./components/Navbars/AdminNavbar";
import Footer from "./components/Footer/Footer";
import { useSelector } from "react-redux";

function Layout({ children, client ,routes}) {
  const { users } = useSelector((state) => state.users);
  const userData = users && users[0] && users[0].data;

  return (
    <div className="wrapper">
      {console.log(routes)}
      {userData ? <Sidebar users={userData} client={client} routes={routes} /> : null}
      <div className="main-panel">
        {userData ? <AdminNavbar users={userData} client={client} /> : null}
        <div className="content">{children}</div>
        <Footer />
        <div
          className="close-layer"
          onClick={() => document.documentElement.classList.toggle("nav-open")}
        />
      </div>
    </div>
  );
}

export default Layout;
